import { createAppStore } from '@app/core/stores';
import { CreateFragmentFormValues } from '../screens/add/useFragmentForm';

interface FragmentCreationState {
  exportEnabled: boolean;
  draftByStation: Record<string, Partial<CreateFragmentFormValues>>;

  // Actions
  toggleExport: (enabled: boolean) => void;
  setFormValues: (stationId: string, values: Partial<CreateFragmentFormValues>) => void;
  getFormValues: (stationId: string) => Partial<CreateFragmentFormValues> | undefined;
  clearFormValues: (stationId: string) => void;
}

/** Persisted subset (used for createAppStore second generic). */
type PersistedFragmentCreationState = Pick<FragmentCreationState, 'exportEnabled'>;

export const useFragmentCreationStore = createAppStore<
  FragmentCreationState,
  PersistedFragmentCreationState
>('FragmentCreationStore', {
  persist: {
    name: 'app.fragments',
    version: 1,
    partialize: (state) => ({
      exportEnabled: state.exportEnabled,
    }),
  },
})((set, get) => ({
  // Initial state
  exportEnabled: false,
  draftByStation: {},

  // Toggle export enabled
  toggleExport: (enabled) => {
    set({ exportEnabled: enabled });
  },

  // Set form values for a specific station
  setFormValues: (stationId, values) => {
    set((state) => ({
      draftByStation: {
        ...state.draftByStation,
        [stationId]: values,
      },
    }));
  },

  // Get form values for a specific station
  getFormValues: (stationId) => {
    return get().draftByStation[stationId];
  },

  // Clear form values for a specific station
  clearFormValues: (stationId) => {
    set((state) => {
      const { [stationId]: _, ...rest } = state.draftByStation;
      return { draftByStation: rest };
    });
  },
}));
